import {
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/LookUserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import TiejunPicker from "src/components/common/TiejunPicker";
import MerchantInfo from "src/components/common/MerchantInfo";
import UserPicker from "src/components/common/LookserPicker";
import {QRCODE_TYPE_LABELS, QRCODE_TYPES} from "src/config/constants";
const roleLevels = Object.values(QRCODE_TYPES);
const LookMerchantParentDialog = ({ merchant, open, onFinish, onClose }) => {
  const [parent, setParent] = useState({});

  const [form, setForm] = useState({
    remark: '',
    codeType:'',
    orderSn:'',
  });

  useEffect(() => {
    if(merchant&&merchant.merchant&&merchant.merchant.mid){
      setParent({
        ...merchant.merchant,
        avatar: merchant.merchant.logo ? 'https://oss.xunyetech.xyz' + merchant.merchant.logo : '',
      });
    }
  }, [merchant])

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    if(!parent.mid){
      alert('请选择商户');
      return false
    }
    if(!form.codeType){
      alert('请选择二维码类别');
      return false
    }
    const { msg } = await asyncRequest({
      path: "/qrcode/bind",
      data: {
        cid: merchant.cid,
        mid:parent.mid,
        ...form
      },
    });
    alert(msg, "success");

    setForm({
      remark: "",
      codeType:'',
      orderSn:'',
    });
    setParent({});
    onFinish();
  }

  function handleSelectTiejun() {
    TiejunPicker({
      onSelect(val) {
        setParent(val.user);
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setParent(val);
      },
    });
  }

  return (
    <FormDialog title={parent&&parent.mid?'更新商户':'绑定商户'} open={open} onClose={onClose} onConfirm={handleDialogConfirm} sx={{minWidth: 200}}>
      {/* <FormItem title="商户" required>
        <Stack direction="row" alignItems="center" spacing={2}>
          <MerchantInfo {...merchant} enablePreview={false} />
        </Stack>
      </FormItem> */}

      <FormItem title="选择商户" required>
        <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectUser}>
          <UserInfo {...(parent || {})} enablePreview={false} />
        </Stack>
      </FormItem>
      <FormItem title="二维码类型" required>
        <FormControl size="small">
          <InputLabel>二维码类型</InputLabel>
          <Select
            label="二维码类型"
            value={form.codeType}
            onChange={(e) => {
              setForm({
                ...form,
                codeType: e.target.value,
              });
            }}
            style={{width: 250}}
          >
            {[null, ...roleLevels].map((roleLevel, idx) => (
              <MenuItem key={idx} value={roleLevel} name={roleLevel}>
                {idx == 0 ? "全部" : QRCODE_TYPE_LABELS[roleLevel]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FormItem>
      {/* <FormItem title="理由" required>
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem> */}
      <FormItem title="设备编码">
        <TextField fullWidth value={form.orderSn} size="small" placeholder="请输入设备编码(orderSn)" onChange={(e) => handleIptChange("orderSn", e.target.value)} />
      </FormItem>
      <FormItem title="理由">
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default LookMerchantParentDialog;
